import type { CollaboratorPermissions, GeneralPermissions } from 'store/data/collaborators';
import type { Action } from 'types/store/types';
import type { GenericMap } from 'types/index';

export interface State {
	projectId: string | null;
	projectRoles: {
		byId: RolesMap;
		byProjectId: GenericMap<{
			ids: string[];
			fetched: boolean;
			metadata: {
				searchTerm: string;
			};
		}>;
	};
	templateRoles: {
		byId: TemplateRolesMap;
		ids: {
			owned: string[];
			shared: string[];
			public: string[];
		};
		fetched: boolean;
		metadata: {
			searchTerm: string;
			activeTab: TemplateRolesHeaderTab;
		};
	};
}

export enum TemplateRolesHeaderTab {
	OWNED = 'owned',
	// TODO: Add back in the future
	// ORGANIZATION = 'organization',
	SHARED = 'shared'
}

export type RolesData = {
	roles: Role[];
	rolesMap: RolesMap;
};

// TODO: needs rethinking
export type TemplateRolesData = {
	roles: {
		owned: TemplateRole[];
		shared: TemplateRole[];
		public: TemplateRole[];
	};
	rolesMap: {
		owned: TemplateRolesMap;
		shared: TemplateRolesMap;
		public: TemplateRolesMap;
	};
};

export type Role = {
	projectId: string;
	id: string;
	name: string;
	description: string;
	permissions: CollaboratorPermissions;
};

export type ShareListData = {
	projectShareList: {
		current: string[];
		initial: string[];
	};
	userShareList: {
		current: string[];
		initial: string[];
	};
	fetched: boolean;
};

export type TemplateRole = {
	id: string;
	name: string;
	description: string;
	publicAccess: boolean;
	permissions: GeneralPermissions;
	shareList: ShareListData;
};

export type NewRole = Omit<Role, 'id'>;
export type NewTemplateRole = Omit<TemplateRole, 'id' | 'shareList'>;

export type RolesMap = GenericMap<Role>;
export type TemplateRolesMap = GenericMap<TemplateRole>;

export enum ActionTypes {
	// TEMPLATE ROLES
	GET_TEMPLATE_ROLES = 'data/roles/GET_TEMPLATE_ROLES',
	GET_ROLE_TEMPLATE_SHARE_LIST = 'data/roles/GET_GET_ROLE_TEMPLATE_SHARE_LIST',
	// PROJECT ROLES
	GET_ROLES = 'data/roles/GET_ROLES',
	CREATE_ROLE = 'data/roles/CREATE_ROLE',
	UPDATE_ROLE = 'data/roles/UPDATE_ROLE',
	DELETE_ROLE = 'data/roles/DELETE_ROLE',
	ASSIGN_ROLE = 'data/roles/ASSIGN_ROLE'
}

export type GetTemplateRolesAction = Action<
	ActionTypes.GET_TEMPLATE_ROLES,
	{
		ownedTemplateRoles: TemplateRole[];
		sharedTemplateRoles: TemplateRole[];
		publicTemplateRoles: TemplateRole[];
	}
>;

export type GetRoleTemplateShareListAction = Action<
	ActionTypes.GET_ROLE_TEMPLATE_SHARE_LIST,
	{
		users: string[];
		projects: string[];
		templateRoleId: TemplateRole['id'];
	}
>;

export type GetRolesAction = Action<
	ActionTypes.GET_ROLES,
	{
		projectId: string;
		roles: Role[];
	}
>;

export type CreateRoleAction = Action<
	ActionTypes.CREATE_ROLE,
	{
		projectId: string;
		role: Role;
	}
>;

export type UpdateRoleAction = Action<
	ActionTypes.UPDATE_ROLE,
	{
		projectId: string;
		role: Role;
	}
>;

export type DeleteRoleAction = Action<
	ActionTypes.DELETE_ROLE,
	{
		projectId: string;
		roleId: Role['id'];
	}
>;

export type Actions =
	| GetTemplateRolesAction
	| GetRoleTemplateShareListAction
	| GetRolesAction
	| CreateRoleAction
	| UpdateRoleAction
	| DeleteRoleAction;
